import { render } from "./DriveDesktopAddPhotos.vue?vue&type=template&id=14c1956b&scoped=true&ts=true"
import script from "./DriveDesktopAddPhotos.vue?vue&type=script&lang=ts"
export * from "./DriveDesktopAddPhotos.vue?vue&type=script&lang=ts"

import "./DriveDesktopAddPhotos.vue?vue&type=style&index=0&id=14c1956b&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14c1956b"]])

export default __exports__